import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { useTheme } from "../hooks/useTheme";
import BusinessIcon from "@mui/icons-material/Business";
import LightModeIcon from "@mui/icons-material/LightMode";
import styles from "./ThemeSwitcher.module.scss";

const ORDER = ["default", "light"];

const ICONS = {
  default: BusinessIcon,
  light: LightModeIcon,
};

export default function ThemeSwitcher({ collapsed = false }) {
  const { themeMode, setThemeMode } = useTheme();

  const cycleTheme = () => {
    const idx = ORDER.indexOf(themeMode);
    const next = ORDER[(idx + 1) % ORDER.length];
    setThemeMode(next);
  };

  const Icon = ICONS[themeMode] || BusinessIcon;
  const nextMode = ORDER[(ORDER.indexOf(themeMode) + 1) % ORDER.length];
  const nextLabel = nextMode.charAt(0).toUpperCase() + nextMode.slice(1);
  const label = themeMode.charAt(0).toUpperCase() + themeMode.slice(1);

  const tip = `${label} theme — click for ${nextLabel}`;

  return (
    <div className={`${styles.wrapper} ${collapsed ? styles.collapsed : ""}`}>
      <Tooltip title={tip} arrow placement="right">
        <span className={styles.tooltipAnchor}>
          <button
            type="button"
            className={styles.trigger}
            onClick={cycleTheme}
            aria-label={`Theme: ${label}. Click to switch to ${nextLabel}`}
          >
            <span className={styles.triggerInner}>
              <Icon fontSize="small" />
              {!collapsed && <span className={styles.microLabel}>{label}</span>}
            </span>
          </button>
        </span>
      </Tooltip>
    </div>
  );
}
